import React, {  useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Container, Card, CardContent, Grid, Button, TextField,DialogActions, CircularProgress,Dialog,DialogTitle,DialogContent,DialogContentText } from '@material-ui/core';
import Page from 'src/components/Page';
import Header from 'src/components/Header';
import CropFreeIcon from '@material-ui/icons/CropFree';
import MalzemeSearch from '../../components/Selects/MaterialSearch';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import SendIcon from '@material-ui/icons/Send';
import BarkodPopup from '../../components/BarcodePopup';
import axios from 'src/utils/axios'
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import FilePopupMaterial from '../../components/FilePopupMaterial';
import { getUser,safeRequestParam } from 'src/utils/Common';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  todos: {
    marginTop: theme.spacing(1)
  },
  contentMaterialImage: {
    padding: 0,
    minHeight: 380,
  },
  fields: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  submitMaterialImage: {
    marginTop: theme.spacing(2),
    width: '100%'
  },
}));

function MaterialImageMap() {
  const classes = useStyles();
  const [MalzemeDataResim, setMalzemeDataResim] = useState({});
  const [En, setEn] = useState();
  const [Boy, setBoy] = useState();
  const [Yukseklik, setYukseklik] = useState();
  const [Agirlik, setAgirlik] = useState();
  const [MalzemeStokNo, setMalzemeStokNo] = useState('');
  const [SearchParamDetail, setSearchParamDetail] = useState('');
  const [openBarkod, setOpenBarkod] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openFile, setOpenFile] = useState(false);
  const [Uyari, setUyari] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const SessionUser = getUser();
  const handleClose = () => {
    setOpen(false);
  };
  const setMalzemeImage = (param) => {
    setMalzemeDataResim(param);
    setMalzemeStokNo(param.MALZEME_STOK_NO);
    MaterialImageDetail(param.MALZEME_STOK_NO);
  }
  const MaterialImageDetail = (MaterialCode) => {
    axios.get(`/GetArtemisMaterialsImageDetail/${MaterialCode}`)
      .then(response => {
        setEn(response.data[0]?.EN);
        setBoy(response.data[0]?.BOY);
        setYukseklik(response.data[0]?.YUKSEKLIK);
        setAgirlik(response.data[0]?.AGIRLIK);
        setLoading(false);
      })
  }

  const SendMaterialImageDetail = () => {
    if (MalzemeStokNo === ''){
      setUyari("Lütfen malzeme seçiniz!...");
      setOpen(true);
      return;
    }
    axios.get(`/SetArtemisMaterialsImageDetail/${safeRequestParam(MalzemeStokNo)}/${En}/${Boy}/${Yukseklik}/${Agirlik}/${SessionUser.OrganizationUserId}`)
      .then(() => {
        setUyari("İşleminiz başarı ile gerçekleştirildi...");
        setOpen(true);
        setLoading(false);
        MaterialImageDetail(MalzemeStokNo);
      })
  }

  const malzemeGosterResim = (materialCode) => {
    const data = {
      MALZEME_STOK_NO: materialCode,
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    let newWindow = window.open();
    if (!newWindow) {
      alert('Popup engelleyici aktif. Lütfen bu site için popup\'lara izin verin.');
      return;
    }
    axios.post('/FileImportExport/ArtemisMalzeme', data, config)
      .then((response) => {
        var fileURL = URL.createObjectURL(response.data);
        newWindow.location = fileURL;
        newWindow.document.title = materialCode;
      })
  }
  const handleFileClose = () => {
    handleCamClose('file');
  }
  const handleFileOpen = () => {
    if (MalzemeStokNo === ''){
      setUyari("Lütfen malzeme seçiniz!...");
      setOpen(true);
      return;
    }
    setOpenFile(true);
  }

  const handleBarkodClose = async (barkod) => {
    setOpenBarkod(false);
    setMalzemeStokNo(barkod);
    setMalzemeDataResim({
      MALZEME_STOK_NO: barkod,
      ACIKLAMA: ''
    });
    setSearchParamDetail(barkod);
    MaterialImageDetail(barkod);
  }

  const handleCamClose = () => {
    setLoading(false);
    setOpenFile(false);
  }


  return (
    <Page className={classes.root} title="Malzeme Fotoğraf Eşleme">
      <Container maxWidth="lg">
        <Header />
        <Card>
          <CardContent className={classes.contentMaterialImage}>
            {loading && <CircularProgress
              status={'loading'}
              style={{ marginLeft: '50%' }}
            />}
            <form>
              <div className={classes.fields}>
                <Grid container spacing={3}>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitMaterialImage}
                      onClick={() => setOpenBarkod(true)}
                      endIcon={<CropFreeIcon />}>
                      Barkod Oku
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitMaterialImage}
                      onClick={handleFileOpen}
                      endIcon={<PhotoCameraIcon />}>
                      Resİm Ekle
                    </Button>
                  </Grid>
                  <Grid item xs={12}>
                    <MalzemeSearch
                      setMalzeme={setMalzemeImage}
                      value={{
                        MALZEME_STOK_NO: MalzemeDataResim.MALZEME_STOK_NO,
                        ACIKLAMA: MalzemeDataResim.ACIKLAMA
                      } || ''}
                      searchParam={SearchParamDetail}
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label={'En'}
                      name="EN"
                      type="number"
                      value={En}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => setEn(e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label={'Boy'}
                      name="BOY"
                      type="number"
                      value={Boy}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => setBoy(e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label={'Yükseklik'}
                      name="YUKSEKLIK"
                      type="number"
                      value={Yukseklik}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => setYukseklik(e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      label={'Ağırlık'}
                      name="AGIRLIK"
                      type="number"
                      value={Agirlik}
                      fullWidth
                      required
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(e) => setAgirlik(e.target.value)}
                      variant="outlined"
                    />
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitMaterialImage}
                      onClick={() => malzemeGosterResim(MalzemeStokNo)}
                      endIcon={<ImageSearchIcon />}>
                      MalzemeResmİ
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="contained"
                      color="secondary"
                      className={classes.submitMaterialImage}
                      onClick={SendMaterialImageDetail}
                      endIcon={<SendIcon />}>
                      MerkezeGönder
                    </Button>
                  </Grid>
                </Grid>
              </div>
            </form>

          </CardContent>
        </Card>
      </Container>
      <BarkodPopup
        onClose={handleBarkodClose}
        open={openBarkod}
        ScanTime={0}
        CallScreen={0}
      />
      <FilePopupMaterial
        onClose={handleFileClose}
        FisNo={MalzemeStokNo}
        DosyaTipi={0}
        DosyaTipiText={MalzemeStokNo}
        open={openFile}
      />
       <Dialog
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-slide-title"
          aria-describedby="alert-dialog-slide-description" >
          <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-slide-description">
              {Uyari}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Tamam
          </Button>
          </DialogActions>
        </Dialog>
    </Page>
  );
}

export default MaterialImageMap;
